import { connect, ConnectedProps } from 'react-redux';

import {
  TransferAppActions,
  TransferAppState,
  CustomWallpaper,
} from '@wetransfer/ad-sdk';

import Actions from '@wetransfer/transfer/store/action';
import { State } from '@wetransfer/transfer/store/types';

import { getChannelWallpapers } from './utils';

export const mapState = ({
  route,
  session,
  user,
  consent,
  auth,
  channel,
  layout,
  account,
  transfer,
}: State): {
  channelWallpapers: CustomWallpaper[];
  state: TransferAppState;
} => {
  return {
    channelWallpapers: getChannelWallpapers({
      channelWallpapers: channel.wallpapers,
      accountWallpapers: account.wallpapers,
      user,
    }),
    state: {
      route,
      session,
      user,
      consent,
      auth,
      channel,
      layout,
      transfer,
      acceptedLanguages: (
        window['__session__'] as unknown as {
          user: {
            accepted_languages: string[];
          };
        }
      )?.user?.accepted_languages,
    },
  };
};

export const mapDispatch = (
  dispatch: any
): { dispatchActions: TransferAppActions } => ({
  dispatchActions: {
    appShow: () => dispatch(Actions.Layout.showUI()),
    appHide: () => dispatch(Actions.Layout.hideUI()),
    appSetWallpaperUIStyle: (styles) =>
      dispatch(Actions.Layout.setWallpaperUIStyle(styles)),
    setDropZoneState: (state: boolean) =>
      dispatch(Actions.Layout.setDropZoneState(state)),
  },
});

export const connector = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof connector>;
